import React from "react";
import { motion } from "framer-motion";
import { FaTools, FaBuilding, FaMapMarkerAlt, FaHistory } from "react-icons/fa";
import SectionHeading from "../SectionHeading";

const items = [
  {
    icon: FaTools,
    title: "Services",
    text: "Guniting, Shotcreting, Sand Blasting, Epoxy Work, M.S. Pipe Jointing, Special Repair Works, Industrial Flooring, Color Concrete, and Bridge Lifting.",
  },
  {
    icon: FaBuilding,
    title: "Projects",
    text: "Successfully completed numerous civil projects across Mumbai, Pune, Goa, Chennai, Madhya Pradesh, and Gujarat.",
  },
  {
    icon: FaMapMarkerAlt,
    title: "Locations",
    text: "Head office in Mumbai and a bureau office in Pune.",
  },
  {
    icon: FaHistory,
    title: "Experience",
    text: "Established 26 years ago, delivering reliability and client satisfaction. Registered with various government and semi-government organizations.",
  },
];

function Expertise() {
  return (
    <section id="expertise" className="scroll-mt-36 relative overflow-hidden py-16 sm:py-24 bg-gradient-to-br from-brand-navy via-brand-navy-dark to-brand-navy">
      <div className="absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-brand-yellow/10 blur-3xl" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading eyebrow="What We Bring" title="Our Expertise" light />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
          {items.map(({ icon: Icon, title, text }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex h-full flex-col rounded-2xl border border-white/15 bg-white/10 p-6 sm:p-7 backdrop-blur-sm transition-colors hover:border-brand-yellow/60"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-yellow text-2xl text-brand-navy">
                <Icon aria-hidden="true" />
              </span>
              <h3 className="mt-5 text-xl font-bold text-white">{title}</h3>
              <p className="mt-2 leading-relaxed text-blue-100">{text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Expertise;
